// extracted by mini-css-extract-plugin
var _1 = "JZdIsZh6pIn4qqH8k7NJ";
var _2 = "ATqOqXaeCDCTuNA10yBs";
var _3 = "uKUwqlsfakk2LhMVHDWq";
var _4 = "Boi8JNIERi4y91nuJrK0";
export { _1 as "right", _2 as "root", _3 as "row", _4 as "user" }
